import { useEffect, useRef } from 'react';
import useLmsCourseReviewHook from './useLmsCourseReviewHook';
import useResolutionDialogHook from './useResolutionDialogHook';
import useProgramReviewHook from './useProgramReviewHook';

/**
 * Composes queue list state, program-search state, resolution dialog state,
 * and syncs the grid's open-resolution callback with the dialog opener.
 */
const useLmsCourseReviewPageHook = () => {
  const openResolutionRef = useRef(() => {});

  const queue = useLmsCourseReviewHook({
    onOpenResolution: (item) => openResolutionRef.current(item),
  });

  const programReview = useProgramReviewHook({
    onOpenResolution: (item) => openResolutionRef.current(item),
    onToast: queue.setToast,
  });

  const resolution = useResolutionDialogHook({
    onResolved: () => {
      queue.refreshQueue();
      programReview.refreshAfterResolve();
    },
    onToast: queue.setToast,
  });

  useEffect(() => {
    openResolutionRef.current = resolution.dialog.open;
  }, [resolution.dialog.open]);

  return { queue, resolution, programReview };
};

export default useLmsCourseReviewPageHook;
